import React, { useState } from "react";
import Create from "./Create";

export default () => {
  const [open, setOpen] = useState(false);

  return (
    <button
      className="btn btn-primary btn-hollow pull-right"
      onClick={() => setOpen(true)}
    >
      <i className={`fa fa-fw fa-plus`} />
      New
      <Create close={() => setOpen(false)} open={open} />
    </button>
  );
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Fleets/New.jsx